import FlexLeftDrawerCode from "!!raw-loader!./flexSideDrawer/FlexLeftDrawer";
import FlexRightDrawerCode from "!!raw-loader!./flexSideDrawer/FlexRightDrawer";
import React from "react";
import { ComponentProps } from "../Component";
import Pane, { paneComponent, PaneProps } from "../Pane";
import FlexLeftDrawer from "./flexSideDrawer/FlexLeftDrawer";
import FlexRightDrawer from "./flexSideDrawer/FlexRightDrawer";

export default (props: PaneProps) => {
	const components: ComponentProps[] = [
		paneComponent("Drawer on the left", FlexLeftDrawerCode, FlexLeftDrawer, "The only difference between this two examples is property 'bRightDrawer' on FlexRightDrawer below"),
		paneComponent("Drawer on the right", FlexRightDrawerCode, FlexRightDrawer),
	];

	return (
		<Pane
			components={components}
			imports={"import {FlexSideDrawer} from \"designSystem/index\";"}
			{...props}
		/>
	);
};